import dynamic from 'next/dynamic'
import { FC, memo, useMemo } from 'react'

import CancellationPolicyFilter from './filter-item/cancellation-policy-filter'
import CheckboxFilterItem from './filter-item/checkbox-filter-item'
import { FilterContentContainer, StyledFilterContent } from './styles'
import { FilterType } from '../types'
import { FilterSectionTransport } from '../../../../transports/search-result-listing-static-transport'
import { FilterItemTransport, FilterTransport } from '../../../../transports/filters-configuration-transport'
import { preventEvent } from '../utils'
import RadioFilter from './filter-item/radio-filter'

const DynamicPriceFilterNoSSR = dynamic(() => import('./price-filter'), { ssr: false })

const _getCheckBoxFilter = (filter: FilterTransport, shouldCommit: boolean) => {
    return filter.items.map((filterItem: FilterItemTransport, index: number) => {
        return (
            <CheckboxFilterItem
                filterItem={filterItem}
                filterType={filter.type}
                key={`${filter.type}-${filterItem.value}-${index}`}
                isMultiSelect={filter?.multiple}
                shouldCommit={shouldCommit}
            />
        )
    })
}

interface Props {
    filter: FilterTransport
    filterStaticData: FilterSectionTransport
    filterType: FilterType
    shouldCommit?: boolean
}

const FilterContent: FC<Props> = ({ filter, filterStaticData, filterType, shouldCommit = false }) => {
    const filterItemsList = useMemo(() => {
        switch (filterType) {
            case FilterType.PRICES: {
                return <DynamicPriceFilterNoSSR filter={filter} key={filter.title} shouldCommit={shouldCommit} />
            }
            case FilterType.CANCELLATION_POLICY: {
                return (
                    <CancellationPolicyFilter
                        filterItems={filter.items}
                        key={filter.title}
                        specificFilterStaticData={filterStaticData.specificFilters.cancellationPolicy}
                        shouldCommit={shouldCommit}
                    />
                )
            }
            default: {
                return filter.multiple ? (
                    _getCheckBoxFilter(filter, shouldCommit)
                ) : (
                    <RadioFilter filter={filter} shouldCommit={shouldCommit} />
                )
            }
        }
    }, [filter, filterStaticData, filterType, shouldCommit])

    return (
        <FilterContentContainer
            className={'filter-content'}
            isMultiple={filter.multiple}
            isPriceFilter={filterType === FilterType.PRICES}
            onClick={preventEvent}
        >
            <StyledFilterContent>{filterItemsList}</StyledFilterContent>
        </FilterContentContainer>
    )
}

export default memo(FilterContent)
